'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _bookingMetaDataActions = require('actions/bookingMetaDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchBookingMetaData);

function fetchBookingMetaData() {
    var bookingId, authToken, locale, _ref, bookingMetaData, error;

    return _regenerator2.default.wrap(function fetchBookingMetaData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 26;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_bookingMetaDataActions.BOOKING_META_DATA_REQUESTED);

                case 3:
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 5:
                    bookingId = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 8:
                    authToken = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 11:
                    locale = _context.sent;
                    _context.next = 14;
                    return (0, _apiHelper.getBookingMetaData)(bookingId, authToken, locale);

                case 14:
                    _ref = _context.sent;
                    bookingMetaData = _ref.bookingMetaData;
                    error = _ref.error;

                    if (!bookingMetaData) {
                        _context.next = 22;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _bookingMetaDataActions.bookingMetaDataReceived)(bookingMetaData));

                case 20:
                    _context.next = 24;
                    break;

                case 22:
                    _context.next = 24;
                    return (0, _effects.put)((0, _bookingMetaDataActions.bookingMetaDataRequestFailed)(error));

                case 24:
                    _context.next = 0;
                    break;

                case 26:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchBookingMetaData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchBookingMetaData.js
// module id = 1409
// module chunks = 0